// eslint-disable-next-line
export const env = {
  production: true,
  apiUrl: 'https://api-adm.gek-group.com',
};



// WEBPACK FOOTER //
// ./src/constants/env.js